import { Horizontal, Texto, Vertical } from '@gravitate-js/excalibrr'
import { Card, Form, Radio, Select } from 'antd'
import type { InvoiceConfigurationComponentProps as BillingConfigurationProps } from '../../../../types'
import { InvoiceContacts } from './InvoiceContacts'
import { useModelConfig } from '@/hooks/useModelConfig'
import { getSelectOptions } from '../utils'
import { daysOfWeek } from '../../../constants'

// Define the map with the correct API values
const invoiceGroupingOptions = {
  'By Billing Period': 'By Billing Period',
  'By Order': 'By Order',
  'Base vs. Accessorial': 'Base vs. Accessorial',
}

const billingFrequencyOptions = getSelectOptions(['Daily', 'Weekly', 'Monthly'])
const daysOfWeekOptions = getSelectOptions(daysOfWeek)

export function BillingConfiguration({ ratebook, form }: BillingConfigurationProps) {
  const { config } = useModelConfig()

  return (
    <Horizontal justifyContent='space-between' className='mb-4' gap={24} style={{ overflow: 'visible' }}>
      <Vertical flex={1} style={{ height: '100%', overflow: 'visible' }} gap={12}>
        <Texto category='h5' weight='600'>
          Invoice Configuration
        </Texto>
        <Horizontal gap={40} verticalCenter>
          <Horizontal gap={42} verticalCenter>
            <Texto category='p1'>Invoice Terms:</Texto>
            <Form.Item name='invoice_terms' noStyle>
              <Select
                labelInValue
                style={{ width: '115px' }}
                options={config?.freight_config?.net_terms?.map((term) => ({
                  label: term.name,
                  value: term.days,
                }))}
              />
            </Form.Item>
          </Horizontal>
          <Horizontal gap={24} verticalCenter>
            <Texto category='p1'>Billing frequency:</Texto>
            <Horizontal gap={8} verticalCenter>
              <Form.Item name='billing_frequency' noStyle>
                <Select style={{ width: 120 }} options={billingFrequencyOptions} />
              </Form.Item>

              <Form.Item noStyle shouldUpdate>
                {({ getFieldValue }) =>
                  getFieldValue('billing_frequency') === 'Weekly' && (
                    <Horizontal gap={8} verticalCenter>
                      <Texto category='p2'>on</Texto>
                      <Form.Item name='invoice_day_of_week' noStyle>
                        <Select style={{ width: 120 }} options={daysOfWeekOptions} />
                      </Form.Item>
                    </Horizontal>
                  )
                }
              </Form.Item>
            </Horizontal>
          </Horizontal>
        </Horizontal>
        <Horizontal gap={24} verticalCenter>
          <Texto category='p1' style={{ whiteSpace: 'nowrap' }}>
            Invoice Grouping:
          </Texto>
          <Form.Item name='invoice_grouping' noStyle>
            <Radio.Group style={{ width: 'min-content', whiteSpace: 'nowrap' }} buttonStyle='solid'>
              {Object.entries(invoiceGroupingOptions).map(([display, value]) => (
                <Radio.Button key={value} value={value}>
                  {display}
                </Radio.Button>
              ))}
            </Radio.Group>
          </Form.Item>
        </Horizontal>
      </Vertical>
      <InvoiceContacts ratebook={ratebook} form={form} />
    </Horizontal>
  )
}
